import React, { useState } from "react";

const Triager = ({ onComplete }) => {
	const [scores, setScores] = useState({
		cbtScore: 0,
		dbtScore: 0,
		addictionScore: 0,
	});
	const [currentQuestionSet, setCurrentQuestionSet] = useState("intro");
	const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);

	const questionSets = {
		cbt: [
			"How frequently do you find yourself caught in negative thought patterns?",
			"How often do you struggle with automatic negative thoughts that seem hard to control?",
			"How frequently do you feel your thoughts significantly impact your emotions and behaviors?",
			"How often do you ruminate on past mistakes or potential future problems?",
		],
		dbt: [
			"How frequently do you struggle to manage intense emotions?",
			"How often do you experience mood swings or emotional instability?",
			"How frequently do you struggle to maintain relationships during emotional distress?",
			"How often do you engage in self-destructive behaviors when feeling overwhelmed?",
		],
		addiction: [
			"How frequently do you feel a loss of control over a substance or behavior?",
			"How often do you try to quit or reduce a habit but find it extremely difficult?",
			"How frequently do your substance use or addictive behaviors interfere with work or personal relationships?",
			"How often do you rely on a substance or behavior to cope with stress or emotions?",
		],
	};

	const getCurrentQuestion = () => {
		if (currentQuestionSet === "intro") return null;
		return questionSets[currentQuestionSet][currentQuestionIndex];
	};

	const handleSubmit = (value) => {
		if (currentQuestionSet !== "intro") {
			const scoreKey = `${currentQuestionSet}Score`;
			const questionCount = questionSets[currentQuestionSet].length;
			const newScore = scores[scoreKey] + (value / questionCount) * 5;

			setScores((prev) => ({
				...prev,
				[scoreKey]: newScore,
			}));
		}

		// Progress to next question or section
		if (
			currentQuestionIndex <
			questionSets[currentQuestionSet].length - 1
		) {
			setCurrentQuestionIndex((prev) => prev + 1);
		} else {
			const sets = ["cbt", "dbt", "addiction"];
			const currentIndex = sets.indexOf(currentQuestionSet);

			if (currentIndex < sets.length - 1) {
				setCurrentQuestionSet(sets[currentIndex + 1]);
				setCurrentQuestionIndex(0);
			} else {
				// Assessment complete - determine recommended therapy
				const recommendedTherapy = determineRecommendedTherapy(scores);
				if (onComplete) {
					onComplete(recommendedTherapy);
				}
			}
		}
	};

	const determineRecommendedTherapy = (scores) => {
		const { cbtScore, dbtScore, addictionScore } = scores;
		const highestScore = Math.max(cbtScore, dbtScore, addictionScore);

		if (highestScore === cbtScore) {
			return "CBT";
		} else if (highestScore === dbtScore) {
			return "DBT";
		} else {
			return "Addiction Counseling";
		}
	};

	const introMessage =
		"Before we start, let's find the most suitable therapy approach for you!\n\nClick Continue below to begin a brief questionnaire:";

	const handleSkip = () => {
		if (onComplete) {
			onComplete("CBT");
		}
	};

	return (
		<div className="w-full max-w-3xl backdrop-blur-lg rounded-3xl shadow-xl overflow-hidden flex flex-col bg-white">
			<div className="w-full text-center p-4">
				<h1 className="text-4xl font-normal text-blue-600 tracking-wide m-2 sm:m-4">
					milburn
				</h1>
				<div className="space-y-4 mb-4">
					{currentQuestionSet === "intro" ? (
						<div className="text-gray-800 p-4">
							<p className="text-base sm:text-lg font-light whitespace-pre-line leading-relaxed mb-10">
								{introMessage}
							</p>
							<div className="flex flex-col sm:flex-row gap-5 justify-center mt-6">
								<button
									onClick={() => setCurrentQuestionSet("cbt")}
									className="px-6 py-3 bg-blue-500 text-white text-lg rounded-lg hover:bg-blue-600 transition-all duration-300 shadow-md">
									Continue
								</button>
								<button
									onClick={handleSkip}
									className="px-6 py-3 bg-gray-500 text-white text-lg rounded-lg hover:bg-gray-600 transition-all duration-300 shadow-md">
									Skip
								</button>
							</div>
						</div>
					) : (
						<div className="text-gray-800 p-4">
							<p className="text-lg font-light mb-6">
								{getCurrentQuestion()}
							</p>
							<div className="grid grid-cols-6 gap-7 sm:gap-10 justify-center w-fit mx-auto">
								{[0, 1, 2, 3, 4, 5].map((value) => (
									<div>
										<button
											key={value}
											onClick={() => handleSubmit(value)}
											className="w-8 h-8 sm:w-12 sm:h-12 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition-all duration-300 shadow-lg text-base sm:text-lg font-medium mb-2">
											{value}
										</button>
										{value === 0 && (
											<span className="text-xs sm:text-base text-center">
												Never
											</span>
										)}
										{value === 5 && (
											<span className="text-xs sm:text-base text-center">
												Always
											</span>
										)}
									</div>
								))}
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default Triager;
